import generateJavaRequest from './services/jrequest';

const jrequest = generateJavaRequest('cart');

export function getCartData() {
  return jrequest('list');
}

export function addCart(conditions) {
  return jrequest('add', conditions, { method: 'post' });
}

export function updateCartNum(conditions) {
  return jrequest('num/update', conditions, { method: 'post' });
}

export function deleteCart(conditions) {
  return jrequest('delete', conditions, { method: 'delete' });
}

export function getTotalPrice(conditions) {
  return jrequest('total', conditions, { method: 'post' });
}
